module.exports = __webpack_public_path__ + "img/two_2.08f709c9.png";